//This feature is used to manage jobsites. It allows users to retrieve and toggle the status of jobsites. 
//It is for users of type business.
//This is for the actual usablity of the kiosk feature.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import foremanActionsService from "./foremanActionsService";

const initialState = {
    selectedWorker: null,
    nextPunchType: null,   //the selected worker's punch data
    isError: null,
    isSuccess: null,   //should only be true if if successfully clocked in or out a worker. 
    isLoading: null,
    message: null,
}



// Get the necxt punch type for a selected worker at a jobsite.
export const getWorkersNextPunchType = createAsyncThunk('kyosk/getNextPunchType', 
    async (selectedWorkerData, thunkAPI) => {
        //Selected worker data contains the workerId(of the selected worker) and the jobsiteId,(of the selected jobsite)
       
        try {
            //Token is the foreman's worker user token. 
            const token = thunkAPI.getState().workerAuth.workerUser.webToken;
            const response = await foremanActionsService.getWorkersNextPunchType(selectedWorkerData, token);
            return response;
        } catch (error) {
            const message = 
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);


export const punchCoWorker = createAsyncThunk('kyosk/punchCoWorker', 
    async (punchData, thunkAPI) => {
        //Selected worker data contains the workerId(of the selected worker) and the jobsiteId,(of the selected jobsite)
        console.log("Selected worker data:", punchData);
        try {
            //Token is the foreman's worker user token. 
            const token = thunkAPI.getState().workerAuth.workerUser.webToken;

            const response = await foremanActionsService.kyoskPunch(punchData, token);
            return response;
        } catch (error) {
            const message = 
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);





export const kyoskSlice = createSlice({
    name:'kyosk',
    initialState,
    reducers:{
        resetKyosk: (state) => initialState,
        setKyoskWorker: (state, action) => {
            state.selectedWorker = action.payload; // payload should be the workerId
        },
    },
    extraReducers: (builder) => {
        builder
        
        .addCase(getWorkersNextPunchType.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(getWorkersNextPunchType.fulfilled, (state, action) => {
            state.isLoading = false;
            state.nextPunchType = action.payload.nextPunchType;
            state.isSuccess = null
            
        })
        .addCase(getWorkersNextPunchType.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.message = action.payload;
        })
        //Puchin a co-worker
        // When successful punch, reset the selected worker and the next punch type.
        .addCase(punchCoWorker.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(punchCoWorker.rejected, (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.message = action.payload;
        })
        .addCase(punchCoWorker.fulfilled, (state,action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.selectedWorker = null; // Reset selected worker after successful punch
            state.nextPunchType = null; // Reset next punch type after successful punch
            state.isError = false;
            state.message = "Punch successful";
        })
    }
});


export const { resetKyosk, setKyoskWorker } = kyoskSlice.actions;
export default kyoskSlice.reducer